export default "__VITE_ASSET__6faa360c__"